module.exports = __webpack_public_path__ + "static/media/meatballs-dark.06b28156.svg";